(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name PagosController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('PagosController', PagosController);

    PagosController.$inject = ["PagosService","$uibModal","UserService","$timeout","$location",'$anchorScroll','Upload'];

    function PagosController(PagosService,$uibModal,UserService,$timeout,$location,$anchorScroll,Upload)
    {
        var vm = this;

         vm.mostrarFacturas = function(){
              PagosService.getFacturas(vm).then(function(data){ 
                vm.facturas = data.facturas; 
            })
        }


    }
})();